export type KeyMap = Record<string, boolean>;

export class Input {
  keys: KeyMap = {};
  stick = { x: 0, y: 0 };
  pointer = { x: 0, y: 0, down: false };
  actions = { a: false, b: false, start: false };
  private unbind: Array<() => void> = [];

  attach(target: HTMLElement | Window = window) {
    const down = (e: KeyboardEvent) => {
      this.keys[e.key.toLowerCase()] = true;
      if ([' ', 'arrowup', 'arrowdown', 'arrowleft', 'arrowright'].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }
    };
    const up = (e: KeyboardEvent) => {
      this.keys[e.key.toLowerCase()] = false;
    };
    window.addEventListener('keydown', down, { passive: false });
    window.addEventListener('keyup', up);
    this.unbind.push(() => {
      window.removeEventListener('keydown', down);
      window.removeEventListener('keyup', up);
    });
    if (target instanceof HTMLElement) {
      const move = (e: PointerEvent) => {
        const r = target.getBoundingClientRect();
        this.pointer.x = e.clientX - r.left;
        this.pointer.y = e.clientY - r.top;
      };
      const pd = (e: PointerEvent) => {
        this.pointer.down = true;
        move(e);
      };
      const pu = () => {
        this.pointer.down = false;
      };
      target.addEventListener('pointermove', move);
      target.addEventListener('pointerdown', pd);
      window.addEventListener('pointerup', pu);
      this.unbind.push(() => {
        target.removeEventListener('pointermove', move);
        target.removeEventListener('pointerdown', pd);
        window.removeEventListener('pointerup', pu);
      });
    }
    return this;
  }

  dispose() {
    for (const fn of this.unbind) fn();
    this.unbind = [];
  }

  axis() {
    let x = this.stick.x;
    let y = this.stick.y;
    if (this.keys['a'] || this.keys['arrowleft']) x -= 1;
    if (this.keys['d'] || this.keys['arrowright']) x += 1;
    if (this.keys['w'] || this.keys['arrowup']) y -= 1;
    if (this.keys['s'] || this.keys['arrowdown']) y += 1;
    const m = Math.hypot(x, y);
    if (m > 1) {
      x /= m;
      y /= m;
    }
    return { x, y };
  }

  pressed(name: 'space' | 'shift' | 'enter' | 'escape') {
    const map = {
      space: ' ',
      shift: 'shift',
      enter: 'enter',
      escape: 'escape',
    };
    return !!this.keys[map[name]] || (name === 'space' && this.actions.a);
  }
}
